import {
    FormFieldContainer,
    Label,
    LabelContainer,
    TextControlShowingEdits,
    ValidationsList
} from '../../../components/Form/FormStyles';
import {EditedProject} from '../EditedProject';

export function ImpactsControl({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    return (
        <FormFieldContainer>
            <LabelContainer>
                <Label htmlFor="impacts">Impacts</Label>
            </LabelContainer>
            <TextControlShowingEdits
                id="impacts"
                value={project.Impacts}
                onChange={(e) =>
                    setProjectAndValidate({
                        ...project,
                        Impacts: project.Impacts.update(e.target.value)
                    })
                }></TextControlShowingEdits>
            <ValidationsList validations={project.Impacts.validations} />
        </FormFieldContainer>
    );
}
